import { RouteUrlList } from '@/libs/RouteList';
const ServiceAlertLoginCheck = [
    'POST',
    RouteUrlList.API_CheckIfLogin.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default ServiceAlertLoginCheck;
